import React from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import { useTranslation } from "react-i18next";

import "./PendingGamesInfoModal.scss";
import FilledButton from "../../FilledButton/FilledButton";
import ImageInfoIcon from "../../../../images/interface-alert-warning-circle-interface-light-purple.svg";

function PendingGamesInfoModal(props: ModalProps) {
  const { onHide } = props;
  const { t } = useTranslation("common");

  return (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="pending-games-info-modal"
      {...props}
    >
      <div className="MobileOnly info-modal-content">
        <Modal.Body className="modal-content">
          <p className="text-center">
            <Image
              src={ImageInfoIcon}
              alt="hourglass"
              height={105}
              width={105}
            />
          </p>
          <h2>{t("pending_game_entries")}</h2>
          <p className="explainer">
            {t("there_is_no_score_for_this_game_key")}
          </p>
          <FilledButton onClick={onHide} style={{ height: 52 }}>
            {t("close")}
          </FilledButton>
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default PendingGamesInfoModal;
